module.exports = __webpack_public_path__ + "static/media/questions-bg.c1ccfdc7.jpg";